module.exports = __webpack_public_path__ + "img/Invasion-INCA_10X_IC.bbf7bc53.png";